import { handleTestSelection } from "./testSelection.js";
import { removeItem } from "./index.js";
import { getSampleTypeSetsInXChooseY } from "../sampleTypes.js";

// add selected xChooseY panel
export function addSelectedXChooseYPanel(panelId, selectProp, supportObj) {
  let { selectedXChooseYPanelIdList } = supportObj;
  // select xChooseY panel and its contents
  handleXChooseYSelection(panelId, selectProp, true, supportObj);
  // add xChooseY panel to selectedXChooseYPanelList
  selectedXChooseYPanelIdList.push(panelId);
}

// remove selected xChooseY panel
export function removeSelectedXChooseYPanel(panelId, selectProp, supportObj) {
  let { selectedXChooseYPanelIdList, bundleList, selectedCustomPanelIdList, selectedDiscountPanelIdList, selectedTestIdList, shortcutList, selectedShortcutIdList } = supportObj;
  // de-select xChooseY panel
  handleXChooseYSelection(panelId, selectProp, false, supportObj);
  // if the multiChoosePanel is selected solely
  if (selectedXChooseYPanelIdList.includes(panelId)) {
    // remove multiChoosePanel from selectedList
    removeItem(panelId, selectedXChooseYPanelIdList);
  }
  else {
    // check whether it belongs to any custom panel
    let selectedCustomPanelList = bundleList.filter(b => selectedCustomPanelIdList.includes(b.bundleId));
    selectedCustomPanelList.forEach(customPanel => {
      removeXChooseYFromCustomPanel(panelId, customPanel, selectProp, customPanel.bundleId, selectedCustomPanelIdList, supportObj);
    });

    // check whether it belongs to any shortcuts
    let selectedShortcutList = shortcutList.filter(shortcut => selectedShortcutIdList.includes(shortcut.id));
    selectedShortcutList.forEach(shortcut => {
      removeXChooseYFromShortcut(panelId, shortcut, selectProp, shortcut.id, selectedShortcutIdList, supportObj);
    })    
  }

  if (selectProp === "isSelect") {
    removeSelectedXChooseYPanelInEditOrder(panelId, supportObj);
  }
}

// select or de-select discount panel according to isSelectPanel value
export function handleXChooseYSelection(panelId, selectProp, isSelectPanel, supportObj) {
  let { bundleList, testNodeList } = supportObj;
  let xChooseYPanel = bundleList.find(b => b.bundleId === panelId);
  if (xChooseYPanel) {
    // select/de-select the panel itself according to isSelectPanel
    xChooseYPanel[selectProp] = isSelectPanel;
    // select the tests that user clicked
    let { selectedZoomerIdList, selectedSupplementIdList } = xChooseYPanel;
    let testIdList = (selectedZoomerIdList ? selectedZoomerIdList : [])
      .concat(selectedSupplementIdList ? selectedSupplementIdList : []);
    let selectedTestNodeList = testNodeList
        .filter(t => testIdList.includes(t.id));
    selectedTestNodeList.forEach(node => {
      handleTestSelection(node, selectProp, isSelectPanel);
    });
    // update sampleTypes info
    xChooseYPanel.sampleTypeSets = isSelectPanel 
      ? getSampleTypeSetsInXChooseY(xChooseYPanel, testNodeList)
      : { blood: new Set(), nonBlood: new Set(), dryIce: new Set() };
  }
}

function removeSelectedXChooseYPanelInEditOrder(panelId, supportObj) {
  let { editOrderItemList, bundleList, shortcutList } = supportObj;
  let xChooseYPanel = editOrderItemList.find(item => item.item_id === panelId && item.category === "xChooseY");
  removeItem(xChooseYPanel, editOrderItemList);

  // check whether it belongs to any custom panel
  editOrderItemList.filter(item => item.category === "customPanel").forEach(customPanel => {
    let customPanelOnMenu = bundleList.find(b => b.bundleId = customPanel.item_id);
    removeXChooseYFromCustomPanel(panelId, customPanelOnMenu, "isSelect", customPanel, editOrderItemList, supportObj);
  });

  // check whether it belongs to any shortcuts
  editOrderItemList.filter(item => item.category === "shortcut").forEach(shortcut => {
    let shortcutOnMenu = shortcutList.find(s => s.id === shortcut.item_id);
    removeXChooseYFromShortcut(panelId, shortcutOnMenu, "isSelect", shortcut, editOrderItemList, supportObj);
  });
}

function removeXChooseYFromCustomPanel(panelId, customPanel, selectProp, removedCustomPanel, removeFromList, supportObj) {
  let { testNodeList, bundleList, selectedDiscountPanelIdList, selectedTestIdList } = supportObj;
  if (!customPanel) {
    return;
  }
  let xChooseYPanel = bundleList.find(b => b.bundleId === panelId);
  // if belongs to current custom panel
  if (customPanel.selectedXChooseYPanelList.includes(xChooseYPanel)) {
    // de-select custom panel
    customPanel[selectProp] = false;
    // remove current customPanel
    removeItem(removedCustomPanel, removeFromList);
    // de-select current selected xChooseY panel and its selectedTests
    xChooseYPanel[selectProp] = false;
    let testIdList = xChooseYPanel.selectedZoomerIdList
      .concat(xChooseYPanel.selectedSupplementIdList);
    let selectedTestNodeList = testNodeList.filter(node => testIdList.includes(node.id));
    selectedTestNodeList.forEach(node => {
      handleTestSelection(node, selectProp, false)
    });
    // add remaining selected xChooseY panels in this panel
    let index = customPanel.selectedXChooseYPanelList.indexOf(xChooseYPanel);
    customPanel.selectedXChooseYPanelList.splice(index, 1);
    customPanel.selectedXChooseYPanelList.forEach(p => {
      addSelectedXChooseYPanel(p.bundleId, selectProp, supportObj);
    });

    // select all tests && discount panels belong to this panel
    customPanel.bundleItemList.forEach((content) => {
      if (content.itemType === "official bundle") {
        let foundPanel = bundleList.find(panel => panel.bundleId === content.itemId && !panel.quantity);
        if (foundPanel) {
          selectedDiscountPanelIdList.push(foundPanel.bundleId);
        }
      }
      else {
        let testNode = testNodeList.find(t => t.id === content.itemId);
        if (testNode) {
          selectedTestIdList.push(testNode.id);
        }
      }
    });
  }
}

function removeXChooseYFromShortcut(panelId, shortcut, selectProp, removedShortcut, removeFromList, supportObj) {
  if (!shortcut) {
    return;
  }
  let { selectedTestIdList, selectedDiscountPanelIdList, selectedXChooseYPanelIdList, selectedCustomPanelIdList } = supportObj;
  let { testIdList, discountPanelIdList, customPanelIdList, selectedXChooseYPanelList } = shortcut;
  let index = selectedXChooseYPanelList.map(xChooseY => xChooseY.bundleId).indexOf(panelId);
  if (index > -1) { // belongs to current shortcut or current shortcut's custom panel
    let foundXChooseY = selectedXChooseYPanelList[index];
    // de-select & remove current shortcut
    shortcut[selectProp] = false;
    removeItem(removedShortcut, removeFromList);
    // add tests to selected list
    testIdList.forEach(id => {
      selectedTestIdList.push(id);
    });
    // add discount panels to selected list
    discountPanelIdList.forEach(id => {
      selectedDiscountPanelIdList.push(id);
    });
    // remove current xChooseY
    let remainingXChooseYList = [...selectedXChooseYPanelList];
    remainingXChooseYList.splice(index, 1);
    // add all remaining xChooseY panels(not belong to custom panels) to selected list
    remainingXChooseYList.filter(p => !p.customPanelId).forEach(xChooseY => {
        selectedXChooseYPanelIdList.push(xChooseY.bundleId);
      });
    // add remaining custom panels to selected list
    let remainingCustomPanelIdList = [...customPanelIdList];
    if (foundXChooseY.customPanelId) {
      // xChooseY belong to a custom panel in current shortcut
      // remove the custom panel that included this xChooseY
      let customPanelIdIndex = customPanelIdList.indexOf(foundXChooseY.customPanelId);
      if (customPanelIdIndex > -1) {
        remainingCustomPanelIdList.splice(customPanelIdIndex, 1);
      }
    }
    remainingCustomPanelIdList.forEach(id => {
      selectedCustomPanelIdList.push(id); 
    });
  }
}